module.exports = __webpack_public_path__ + "static/img/question.7573ec3d.svg";